<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-cogs"></i></div>
          <div>
            <div class="panel-title">Submission Configure</div>
            <div class="panel-sub">Server and channel configuration for submission providers</div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tab-bar" v-if="currentUser.u.is_admin == 1">
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'deporder-trp' }"
          @click="active_tab = 'deporder-trp'"
        >
          <i class="fa fa-server"></i> Deporder (TRP)
        </button>
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'deporder' }"
          @click="active_tab = 'deporder'"
        >
          <i class="fa fa-server"></i> Deporder
        </button>
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'fdle' }"
          @click="active_tab = 'fdle'"
        >
          <i class="fa fa-envelope"></i> FDLE
        </button>
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'acha' }"
          @click="active_tab = 'acha'"
        >
          <i class="fa fa-hospital"></i> AHCA
        </button>
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'apostille' }"
          @click="active_tab = 'apostille'"
        >
          <i class="fa fa-stamp"></i> Apostille
        </button>
      </div>

      <!-- Tab content -->
      <div class="tab-body">
        <v-deporder v-if="active_tab === 'deporder-trp'" key="trp"></v-deporder>
        <v-deporder v-if="active_tab === 'deporder'" :trp="false" key="dep"></v-deporder>
        <v-fdle    v-if="active_tab === 'fdle'"></v-fdle>
        <v-acha    v-if="active_tab === 'acha'"></v-acha>
        <v-apostille v-if="active_tab === 'apostille'"></v-apostille>
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import vDeporder  from "@/pages/backend/settings/server_config/deporder";
import vFdle      from "@/pages/backend/settings/server_config/fdle";
import vAcha      from "@/pages/backend/settings/server_config/acha";
import vApostille from "@/pages/backend/settings/server_config/apostille";

export default {
  components: { vDeporder, vFdle, vAcha, vApostille },
  data() {
    return {
      active_tab: "deporder-trp",
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "admin.dashboard" },
        { id: 2, title: "Setting",   route: "" },
        { id: 3, title: "Submission Configure", route: "" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 24px;
  font-family: $font;
}

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13,27,62,0.08);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 20px 24px 18px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbff;
  gap: 14px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, $blue, #2176ae);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 15px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 12px;
  color: #8a94a6;
  margin-top: 2px;
}

/* ── Tabs ── */
.tab-bar {
  display: flex;
  gap: 4px;
  padding: 14px 20px 0;
  border-bottom: 2px solid #f0f3fa;
  background: #fafbff;
  flex-wrap: wrap;
}

.tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px 8px 0 0;
  border: 1.5px solid transparent;
  border-bottom: none;
  background: transparent;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  position: relative;
  bottom: -2px;

  i { font-size: 12px; }

  &:hover:not(.active) {
    color: $blue;
    background: #f0f8fd;
  }

  &.active {
    color: $blue;
    background: #fff;
    border-color: #f0f3fa;
    border-bottom-color: #fff;
  }
}

/* ── Tab body ── */
.tab-body {
  padding: 28px 32px 32px;
  max-width: 640px;
}
</style>

<!-- Global overrides — also styles sub-component loading state pushed into sub-components -->
<style lang="scss">
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;
$green: #276749;

.tab-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  color: #8a94a6;
  font-size: 13px;
  font-family: 'Segoe UI', sans-serif;
  i { color: #389ad4; font-size: 18px; }
}

.tab-body {
  /* Labels */
  label {
    font-size: 12px;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 5px;
    font-family: $font;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  /* Inputs */
  input.form-control,
  select.form-control {
    height: 38px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    box-shadow: none;
    transition: border-color 0.15s;

    &:focus {
      border-color: $blue;
      box-shadow: none;
      outline: none;
    }

    &.border-danger {
      border-color: #c62828 !important;
    }

    &:disabled {
      background: #f7f9fc;
      color: #9aa0ae;
    }
  }

  /* Password input-group */
  .input-group {
    .form-control {
      border-right: none;
      border-radius: 8px 0 0 8px;
    }

    .input-group-append {
      .input-group-text {
        background: #fff;
        border: 1.5px solid $border;
        border-left: none;
        border-radius: 0 8px 8px 0;
        color: #6b7280;
        transition: border-color 0.15s;
      }
    }

    &:focus-within {
      .form-control,
      .input-group-text {
        border-color: $blue;
      }
    }
  }

  /* Error message */
  .text-danger {
    font-size: 11px;
    margin-top: 3px;
    display: block;
  }

  /* Section headings inside sub-components */
  h5, h6 {
    font-size: 13px;
    font-weight: 700;
    color: $dark;
    font-family: $font;
    margin-bottom: 14px;
  }

  hr {
    border-color: #f0f3fa;
    margin: 20px 0;
  }

  /* Submit button */
  button[ref],
  button.btn-success,
  button.btn.btn-success {
    float: none !important;
    display: inline-flex !important;
    align-items: center;
    height: 38px;
    padding: 0 22px;
    border-radius: 8px;
    border: none;
    background: $green !important;
    color: #fff !important;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.15s;

    &:hover { background: #1d5230 !important; }
    &:disabled { opacity: 0.6; cursor: default; }
  }

  /* Form group spacing */
  .form-group {
    margin-bottom: 18px;
  }
}
</style>
